module.exports = __webpack_public_path__ + "img/tp.a92ab48.webp";